// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main_ukYALWg3OFC2_koJ4lZ4R"};